import ko from "knockout";
import metaCache from "flow/utils/metaCache";
import register from "flow/knockout/register";

register.registerKnockoutExtension("meta", function (target: KnockoutObservable<string>, performLookup: boolean) {
    return ko.pureComputed(() => {
        return performLookup ? metaCache.lookup(target(), target()) : target();
    });
});
